// src/store/slices/blogSlice.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createGenericSlice } from './genericSliceFactory';
import { apiMethods } from '../../services/api';
import type { Blog } from '@/types';

const blogSlice = createGenericSlice<Blog>({
    name: 'blogs',
    endpoint: '/blogs',
});

export const {
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = blogSlice.actions;

export const {
    fetchActive: fetchActiveBlogs,
} = blogSlice.thunks;

export const incrementBlogViews = createAsyncThunk(
    'blogs/incrementViews',
    async (id: string, { rejectWithValue }) => {
        try {
            await apiMethods.patch(`/blogs/${id}/view`);
            return id;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to increment blog views');
        }
    }
);

export default blogSlice.reducer;
